import * as React from "react";

import BG01, { BG01Props } from "@stadium/shared/src/components/plasmic/BG01";
import BG02 from "@stadium/shared/src/components/plasmic/BG02";
import { BG02Props } from "@stadium/shared/src/components/plasmic/BG02/constants";
import BG03, { BG03Props } from "@stadium/shared/src/components/plasmic/BG03";

import {
  BentoGridVariant,
  BG_01,
  BG_02,
  BG_03,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export interface BG01BentoGridProps {
  contentHeading?: BG01Props["contentHeading"];
  contentDescription?: BG01Props["contentDescription"];
  buttonText?: BG01Props["buttonText"];
  buttonLinkType?: BG01Props["buttonLinkType"];
  buttonOpenInNewTab?: BG01Props["buttonOpenInNewTab"];
  buttonOtherUrl?: BG01Props["buttonOtherUrl"];
  buttonCategorySlug?: BG01Props["buttonCategorySlug"];
  card1?: BG01Props["card1"];
  card2?: BG01Props["card2"];
  card3?: BG01Props["card3"];
  card4?: BG01Props["card4"];
}
export interface BG02BentoGridProps {
  heading?: BG02Props["heading"];
  countryCard?: BG02Props["countryCard"];
  brandCard?: BG02Props["brandCard"];
  brandsPlatform?: BG02Props["brandsPlatform"];
  testimonial?: BG02Props["testimonial"];
  review?: BG02Props["review"];
}

export interface BG03BentoGridProps {
  bg03Heading?: BG03Props["bg03Heading"];
  bg03Card1?: BG03Props["bg03Card1"];
  bg03Card2?: BG03Props["bg03Card2"];
  bg03Card3?: BG03Props["bg03Card3"];
  bg03Card4?: BG03Props["bg03Card4"];
}

export interface BentoGridProps extends BG01BentoGridProps, BG02BentoGridProps, BG03BentoGridProps {
  variant?: BentoGridVariant;
  className?: string;
}

const BentoGrid: React.FC<Readonly<BentoGridProps>> = (props) => {
  const { variant = BG_01 } = props;

  switch (variant) {
    case BG_01: {
      return <BG01 {...props} />;
    }

    case BG_02: {
      return <BG02 {...props} />;
    }

    case BG_03: {
      return <BG03 {...props} />;
    }

    default:
      return null;
  }
};

export default BentoGrid;
